const types = {
  FETCH_CONSIGNER_VEHCILES_START: 'consigner/vehicles/FETCH_CONSIGNER_VEHCILES_START',
  FETCH_CONSIGNER_VEHCILES_SUCCESS: 'consigner/vehicles/FETCH_CONSIGNER_VEHCILES_SUCCESS',
  RESET_CONSIGNER_VEHCILES: 'consigner/vehicles/RESET_CONSIGNER_VEHCILES',
  FETCH_FILTERS_START: 'consigner/vehicles/FETCH_FILTERS_START',
  FETCH_FILTERS_SUCCESS: 'consigner/vehicles/FETCH_FILTERS_SUCCESS',
  FETCH_ITINERARY_DATA_START: 'consigner/vehicles/FETCH_ITINERARY_DATA_START',
  FETCH_ITINERARY_DATA_SUCCESS: 'consigner/vehicles/FETCH_ITINERARY_DATA_SUCCESS',
  FETCH_PATH_DETAILS_START: 'consigner/vehicles/FETCH_PATH_DETAILS_START',
  FETCH_PATH_DETAILS_SUCCESS: 'consigner/vehicles/FETCH_PATH_DETAILS_SUCCESS',
  FETCH_CURRENT_LOCATION_START: 'consigner/vehicles/FETCH_CURRENT_LOCATION_START',
  FETCH_CURRENT_LOCATION_SUCCESS: 'consigner/vehicles/FETCH_CURRENT_LOCATION_SUCCESS',
  DOWNLOAD_REPORT: 'consigner/vehicles/DOWNLOAD_REPORT',
};

export default types;
